const insuranceLut: string[] = [
  'Other',
  'Medicare',
  'Medicaid',
]

export default insuranceLut
